//#region src/common.types.ts
let LogLevel = /* @__PURE__ */ function(LogLevel$1) {
	LogLevel$1["info"] = "info";
	LogLevel$1["warn"] = "warn";
	LogLevel$1["error"] = "error";
	LogLevel$1["debug"] = "debug";
	LogLevel$1["trace"] = "trace";
	LogLevel$1["fatal"] = "fatal";
	return LogLevel$1;
}({});
/**
* Mapping of log levels to their numeric values.
*/
const LogLevelPriority = {
	[LogLevel.trace]: 10,
	[LogLevel.debug]: 20,
	[LogLevel.info]: 30,
	[LogLevel.warn]: 40,
	[LogLevel.error]: 50,
	[LogLevel.fatal]: 60
};
/**
* Mapping of numeric values to their log level names.
*/
const LogLevelPriorityToNames = {
	10: LogLevel.trace,
	20: LogLevel.debug,
	30: LogLevel.info,
	40: LogLevel.warn,
	50: LogLevel.error,
	60: LogLevel.fatal
};

//#endregion
export { LogLevel, LogLevelPriority, LogLevelPriorityToNames };